import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=3624a15e"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionFeaturedProducts: require('/opt/build/repo/components/section/FeaturedProducts.vue').default,LayoutShopHeader: require('/opt/build/repo/components/layout/ShopHeader.vue').default,SectionPromotion: require('/opt/build/repo/components/section/Promotion.vue').default,CategoryList: require('/opt/build/repo/components/category/List.vue').default,LayoutBanner: require('/opt/build/repo/components/layout/Banner.vue').default})
